import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./home/Home";
import MobileHome from "./Mobile/home/Home"
import Login, { isLoggedIn } from "./login/Login";
import Writing from "./writing/Writing";
import Content from "./content/Content";
import MoblieContent from "./Mobile/content/Content";
import AboutMe from "./aboutMe/AboutMe";
import MobileAboutMe from "./Mobile/aboutMe/AboutMe";
import { isMobile } from "react-device-detect";

const Router = () => {
    return (
        isMobile ?  // 모바일로 접근할 경우 편집 및 관리자 계정 접근 불가하도록 라우팅 설정
        <Routes>
            <Route path="/" element={<MobileHome />} />
            <Route path='/aboutme' element={<MobileAboutMe />} />
            <Route path="/content/:id" element={<MoblieContent />} />
        </Routes>
        :
        <Routes>
            <Route path="/" element={<Home />} />
            <Route 
                path="/login" 
                element={isLoggedIn() ? <Navigate to="/" /> : <Login />} 
            />
            <Route path="/writing" element={<Writing />} />
            {/* 동적 파라미터 id 활용 */}
            <Route path="/content/:id" element={<Content />} />
            <Route path="/modify/:id" element={<Writing />} />
            <Route path='/aboutme' element={<AboutMe />} />
        </Routes>
    );
}

export default Router;